module.exports = __webpack_public_path__ + "img/chat-icon.693c9500.svg";